import { combineReducers, createStore, Store } from "lib/store/v3";
import { GoodsActions as Goods } from "./Goods/index";
import { createStoreLogger } from "lib/store/v3/createStoreLogger";

const reducer = combineReducers({ Goods }, createStoreLogger("Goods"));

export type GoodsStore = Store<typeof reducer>;

export const { useSelector: useGoodsSelector, ...GoodsStore } = createStore(reducer);
